import { defineMessages } from 'react-intl';

export default defineMessages({
  cantConnect: "Can't connect with Ledger device",
  firstCheck: 'Check that you entered the correct PIN',
  secondCheck: 'Check that you selected the Ethereum app',
  thirdCheck: 'Update to the latest version of the Ethereum app',
  fourthCheck: 'Check that you have ‘contract data’ enabled',
  more: 'More information',
});
